export default function initialState() {
    return {
        locations: {
            __loading__: false,
            __error__: null
        }
    };
}
